import { useState, useEffect } from 'react';

const useScreenSize = () => {

  const [screenSize, setScreenSize] = useState({ isMobile: true, isTablet: false, isDesktop:false});

  useEffect(() => {

    const handleResize = () => {

        let vIsMobile  = window.innerWidth <= 768 ? true : false,
            vIsTablet  = window.innerWidth > 768 && window.innerWidth <= 900 ? true : false ,
            vIsDesktop = window.innerWidth > 900;

        // if anything change trigger update state
        if (screenSize.isMobile !== vIsMobile || screenSize.isTablet !== vIsTablet || screenSize.isDesktop !== vIsDesktop) {
            // let nScreenSize =  }
                setScreenSize(prevSize => ({...prevSize, isMobile:vIsMobile, isTablet:vIsTablet, isDesktop:vIsDesktop}));
                console.log(screenSize,"Screen size has changes");
        }

        // console.log(screenSize);

        

    };

    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [screenSize]);

  return screenSize;
};

export default useScreenSize;